export default __webpack_public_path__ + "static/laagom-block-full-a5ed330333ba4765b0cc3174e869fc8e.png";